import React from 'react';
import { Flex, Button, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useGroupList } from '../hooks/useGroupList';
import GroupItem from '../components/GroupItem';
import HomeHeader from '../components/HomeHeader';

const GroupList = () => {
  const { groups } = useGroupList();

  return (
    <Flex
      pos="relative"
      h="100%"
      flexDirection="column"
      align="center"
      px="1rem"
      pb={8}
    >
      <HomeHeader title="모임 목록" />
      {groups.length === 0 && (
        <Text fontSize="18px" mt="16px">
          모임이 없습니다. 모임을 추가해주세요
        </Text>
      )}
      {groups.map((group) => (
        <Link
          key={group.id}
          to={`/group/${group.id}`}
          style={{ width: '100%' }}
        >
          <GroupItem group={group} />
        </Link>
      ))}
      <Button
        position="fixed"
        bottom="102px"
        right="21px"
        bgColor="#D84E46"
        _active={{
          bgColor: '#AB170F',
        }}
        _hover={{
          bgColor: '#AB170F',
        }}
        borderRadius="26px"
        color="white"
        fontWeight="semibold"
      >
        <Link to="/group/add">모임 생성하기</Link>
      </Button>
    </Flex>
  );
};

export default GroupList;
